import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pill',
  standalone: true,
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.css']
})
export class PillComponent {
  @Input() color: string = '#FDCA13';
}